import { Observable } from 'rxjs';
import { NewExportToExcelService } from '../new-export-to-excel.service';
import { ExportByTypeService } from './export-resolver.model';
import { ExportExecutableParams } from '../export.model';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SPExportExcelService implements ExportByTypeService<ExportExecutableParams, boolean> {
  constructor(private excelExportService: NewExportToExcelService) {}

  execute(params: ExportExecutableParams): Observable<boolean> {
    const { exportOptions, dialogOptions } = params;
    return this.excelExportService.generateWorkbook(
      exportOptions.floorElevatorData,
      dialogOptions,
      // TODO: currently hardcoded in ExportComponent
      exportOptions.localeId
    );
  }
}
